var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sidebar'),_c('navigation'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('loggedindashboardFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }